import BillingDiscrepancyRequestType from './BillingDiscrepancyRequestType'
import BillingDiscrepancyRequestReason from './BillingDiscrepancyRequestReason'
import BillingAction from './BillingAction'

export class BillingDiscrepancyInfo {
    RequestID: number;
    BillingDiscrepancyRequestTypeID?: number;
    BillingDiscrepancyRequestType?: BillingDiscrepancyRequestType;
    BillingDiscrepancyRequestReasonID?: number;
    BillingDiscrepancyRequestReason?: BillingDiscrepancyRequestReason;
    BillingActionID?: number;
    BillingAction?: BillingAction;
}

export default BillingDiscrepancyInfo;